import React, { useContext, useEffect, useState } from "react";
import { emailLinkSent, registerUser } from "../../services/firebase";
import { useNavigate } from "react-router-dom";
import AuthContext from "../../hooks/authContext";
import RegisterStep1 from "../../app/auth/RegisterStep1";
import RegisterStep2 from "../../app/auth/RegisterStep2";
import { getAllEmployee, setUserInfoHistory } from "../../services/apiservices/employee";
import { useToast } from "../../hooks/useToast";

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
const stepsArray = [
  {
    id: 1,
    title: "Create Company Profile",
    subheading: "Step 1",
    content: <></>,
    NextButtonText: "Next",
    CancelButtonText: "Cancel",
  },
  {
    id: 2,
    title: "Company Details",
    subheading: "Step 2",
    content: <></>,
    NextButtonText: "Submit",
    CancelButtonText: "Cancel",
    contentWrapClass: "w-100",
  },
];

const RegisterForm = (props) => {
  const { setCurrentStep, currentStep } = props;
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [empData, setEmpData] = useState(false);
  const auth = useContext(AuthContext);
  //   const styles = useStyles();
 const { toast } = useToast();
  const [errorMessage, setErrorMessage] = useState({});
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [existingData, setExistingData] = useState(null);
  const [alreadyAcount, setAlredyAccount] = useState(false);
  // const [currentStep, setCurrentStep] = useState(1);
  const [state, setState] = useState({
    formState: { username: "", password: "" },
    loading: false,
    sRedirect: "",
    terms: "",
  });

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        await getAllEmployee((res) => {
          setEmpData(res?.data || []);
        });
      } catch (error) {
        console.error("Failed to fetch employees:", error);
      }
    };

    fetchEmployees();
  }, []);

  const goToStep = (step) => {
    setCurrentStep(step);
  };

  const goNext = async () => {
    setState({ ...state, loading: true });
    if (currentStep === 1) {
      const { firstname, lastname, email } = state?.formState;
      const details = { email, firstname, lastname };

      const existingUser = empData?.find((item) => {
        const isDeleted = item?.deleted === true;
        const isCanceled = item?.status === "canceled";
        return item?.email === email && !isDeleted && !isCanceled;
      })

      if (existingUser?.verified === true) {
        setAlredyAccount(true);
        setCurrentStep(1);
        setState({ ...state, loading: false });
        return;
      }

      if (existingUser?.verified === false) {
        try {
          await emailLinkSent(email, existingUser?.companyName);

          toast?.({
            title: "You're Almost There!",
            description: "It looks like you already have an account with this email. Please verify your email to finish setting up your account.",
          });

          navigate("/verify-email-sent");
          localStorage.setItem("verify", "true");
          setState({ ...state, loading: false });
          return;
        } catch (error) {
          console.error("Resend verification error:", error);
          showErrorMessage( "Failed to resend verification email. Please try again.");
          toast?.({
            title: "Failed",
            description: "Failed to resend verification email. Please try again.",
            variant: "destructive"
          });

          setState({ ...state, loading: false });
          return;
        }
      }

      await setUserInfoHistory(email, details);
    }

    let newStep = currentStep < stepsArray?.length ? currentStep + 1 : currentStep;
    setCurrentStep(newStep);
    setState({ ...state, loading: false });
  };

  const handleInputChange = (e, customName = null) => {
      if (customName) {
    setState((prev) => ({
      ...prev,
      formState: { ...prev.formState, [customName]: e },
    }));
  }

 else if (e && e.target && e.target.name) {
    const { name, value } = e.target;
    const finalValue = name === "email" ? value.trim() : value;
    if (name === "email") {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const invalidSequenceRegex = /[\/]{1}|\.{2,}|\/\.|\.\/|[^a-zA-Z0-9._%+-@]/;

    let newEmailError = "";

    if (!emailRegex.test(finalValue)) {
      newEmailError = "Please enter a valid email address.";
    } else if (invalidSequenceRegex.test(finalValue)) {
      newEmailError = "Email contains invalid or unsupported characters.";
    }
     setEmailError(newEmailError);
   }
    setState((prev) => ({
      ...prev,
      formState: { ...prev.formState, [name]: finalValue },
    }));
  }
};

  const handleCancelAll = () => {
    setState({ formState: {} });
  };

  const redirecifloggedin = () => {
    navigate("/dashboard");
  };
  useEffect(() => {
    if (auth.status === true) {
      redirecifloggedin();
    }
  }, [auth.status]);

  const onChangeCheckbox = (event) => {
    setState({
      ...state,
      terms: event.target.checked ? event.target.value : false,
    });
  };

  const industry = [
    { label: "Automotive Services – Auto Detailing", value: "mu6e3gfFqfHp4NSoyCA1" },
    { label: "Building Cleaning & Maintenance", value: "NRop745hbvB5nFNo3gy9" },
    { label: "Cleaning (General Residential/Commercial)", value: "Ivs5bvNvTXa5sMIs1nZT" },
    { label: "Construction – Carpentry", value: "tdyBKdunNfi0f3xrC7Iy" },
    { label: "Construction – Concrete Installation", value: "cM1eWLu4UbaYuKvs6Kcr" },
    { label: "Construction – Construction", value: "HU5h5EHSJo1JvFcGg7cy" },
    { label: "Construction – Demolition Contractor", value: "VMhraTGmurcXZ1OATTVJ" },
    { label: "Construction – Drywall", value: "GVD36PcjQQcspbln6xQ0" },
    { label: "Construction – Electrical Contracting", value: "wuiSBFWKRsM75FqNEcBo" },
    { label: "Construction – Excavation", value: "xav1bVq4fYR8b5kgzc5d" },
    { label: "Construction – Fence Services", value: "KfJnjHPOakLNIHzmbY2y" },
    { label: "Construction – Flooring", value: "zFDtbfJNAbZ8lhaNQl4Q" },
    { label: "Construction – General Contracting", value: "TVnyzcsD8RfUhijixbUN" },
    { label: "Construction – HVAC (Heating, Ventilation, Air Conditioning)", value: "rnEoBRDepCz7J3gnI8kA" },
    { label: "Construction – Installation Services", value: "V42FN0qCRZXI07qycCUF" },
    { label: "Construction – Mechanical Contracting", value: "5pJN3Iem0pfg31PJj47U" },
    { label: "Construction – Painting", value: "38Puv1318ZhpfYWlUY2s" },
    { label: "Construction – Paving", value: "oGS0vlEcp6QrHlmIA3IE" },
    { label: "Construction – Plumbing", value: "V3lIZitKwTFCHY0HNaaQ" },
    { label: "Construction – Remodeling", value: "aW8PzalzERgtnLa6geQI" },
    { label: "Construction – Roofing", value: "zF1tROpWwKsyldlubPBt" },
    { label: "Construction – Tiling", value: "fYKFimqm94OSLlW98jhH" },
    { label: "Construction / Repair Services – Garage Door Services", value: "uyJoyW6gw2gFTZSdx2zf" },
    { label: "Facility Services / Cleaning – Carpet Cleaning", value: "M9nZBPyb2aKohbrP55NB" },
    { label: "Facility Services / Cleaning – Commercial Cleaning", value: "1LlqChnpKLjIcv5gbGoO" },
    { label: "Facility Services / Cleaning – House Cleaning", value: "RuAl2ezrCubTM3aEL3Yv" },
    { label: "Facility Services / Cleaning – Janitorial Services", value: "fj1B99lgi87CW1HufILB" },
    { label: "Facility Services / Cleaning – Pressure Washing", value: "Sqn38RboF5eSdc7jtLj8" },
    { label: "Facility Services / Cleaning – Window Cleaning", value: "UMhjyNIDJmQWXDKD3Sw7" },
    { label: "Facility Services / Maintenance – Property Maintenance", value: "INTO7y64buuAGdcqg1f2" },
    { label: "Landscaper", value: "9R3Yx2bsCaAbr0SHxWMj" },
    { label: "Landscaping - Grounds Maintenance", value: "LNdzWlDMt9gqWjgobMl8" },
    { label: "Landscaping – Irrigation Services", value: "APGiW09l1CwUiCNLaur4" },
    { label: "Landscaping – Landscaping", value: "OKcFRK1jEKZFUdRQ4MQ7" },
    { label: "Landscaping – Lawn Care", value: "I3BJfwh9ZeTCzIQUB6Ht" },
    { label: "Landscaping – Tree Care", value: "NB55s9Y9MnQlcLvkqWm1" },
    { label: "Mechanical & Plumbing Services", value: "81tUSZ4CkQq0wVcEgou1" },
    { label: "Municipal / Landscaping – Snow Removal", value: "OCxWpKcb70TqpresiJkR" },
    { label: "Pest Management Services – Pest Control", value: "u20LKUdquxmhnykEB6dY" },
    { label: "Pet Services – Dog Walking", value: "99PU9Yi6ShAVJkzmDon6" },
    { label: "Pet Services – Pooper Scooper (Pet Waste Removal)", value: "Q4geLTvo62qUYlrONcPM" },
    { label: "Recreational Services / Specialty – Pool & Spa Services", value: "0A4Pka6d3lzDXeYfauUa" },
    { label: "Repair and Maintenance – Handyman", value: "vUAzEwF9QRH6ZHKCxE7n" },
    { label: "Repair Services – Appliance Repair", value: "UQtrSo3Xi5gxhrRQw9An" },
    { label: "Security Services – Locksmith Services", value: "YMQcJqRrcy3jfClMbR0y" },
    { label: "Specialty Restoration Services – Restoration (Fire & Water Damage)", value: "BCxqV6OwlLA2WGv7jrGv" },
    { label: "Specialty Trade Contractors – Chimney Sweep Services", value: "IVQY0PNcsqNcij7ELPMO" },
    { label: "Specialty Trade Contractors – Elevator Services", value: "J20mHvlO5v1tzFHP33mb" },
    { label: "Utilities Services – Well Water Services", value: "XsRyy6P7dhLZMVgit2Ie" },
    { label: "Waste Management – Junk Removal", value: "t1g3B5fLTa4N6Rks4ywr" }
  ];

  const peoples = [
    { label: "1 - 5 People", value: "1 to 5 People" },
    { label: "5 - 10 People", value: "5 to 10 People",},
    { label: "10 - 25 People", value: "10 to 25 People" },
    { label: "26 - 50 People", value: "26 to 50 People" },
    { label: "> 50 People", value: "more than 50 People" },
  ];
  const showErrorMessage = (message) => {
    setError(message);
    setState({ ...state, sRedirect: "", loading: false });
  };

  const userRegister = async (e) => {
    e.preventDefault();

    setError("");
    setState({ ...state, loading: true });
    const { terms } = state;
    const {
      companyName,
      firstname,
      lastname,
      username,
      phoneNumber,
      email,
      password,
      confirmpassword,
      peoples,
      industry,
      website,
      promo
    } = state.formState;
    const emails = email;
    const names = firstname;
    const passwords = password;
    if (terms !== "yes") {
      showErrorMessage("Please Agree with terms");
    } else {
      let newuser = await registerUser({
        companyName: companyName,
        firstName: firstname,
        lastName: lastname,
        email: email,
        username: username,
        phoneNumber: phoneNumber,
        website: website,
        peoples: peoples,
        industry: industry,
        password: password,
        confirmPassword: confirmpassword,
        createdAt: new Date().toISOString(),
        role: "companyUser",
        promocode: promo,
      }, existingData);
      if (newuser?.uid || newuser?.existingUser?.id) {
        await delay(3500);
        navigate("/verify-email-sent");
        localStorage.setItem("verify", "true");
        // let loginRes = await loginWithEmail(emails, passwords);
        // if (loginRes?.token && loginRes?.token !== "") {
        //   setTimeout(() => {
        //     auth.login(loginRes?.token);
        //     navigate("/dashboard");
        //   });
        // }
        setState({ ...state, loading: false });

        // const { subject, content } = EmailTemplate({
        //   subject: "Welcome to ProTeams.io!",
        //   headline: "Welcome to ProTeams.io",
        //   content: `
        //   <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; max-width: 600px; margin: auto; border: 1px solid #eee; border-radius: 10px;">
                    
        //     <div style="text-align: center; margin-bottom: 20px;">
        //      <img src="https://${DOMAINURL}/csmGrayTextLogin.png" alt="ProTeams.io Logo" style="height: 60px;" />
        //     </div>
          
        //    <p style="margin-bottom: 16px;">Hi ${names},</p>
        
        // <p style="margin-bottom: 24px;">You've successfully activated your 14-day free trial, and your journey to smarter workforce management starts now. Whether you're managing service teams, facility staff, or field operators, ProTeams.io gives you the tools to stay organized, connected, and in control.</p>
        
        // <p style="margin-bottom: 16px;">Here's how to make the most of your trial:</p>
        
        // <ul style="margin: 16px 0; padding-left: 20px;">
        //   <li style="margin-bottom: 12px;">Set up your first team - Add team members and assign roles.</li>
        //   <li style="margin-bottom: 12px;">Try out the scheduler - Simplify daily coordination.</li>
        //   <li style="margin-bottom: 12px;">Explore workflows and task assignments - Streamline your operations.</li>
        //   <li style="margin-bottom: 12px;">Use the client manager and issue tracker - Stay proactive and responsive.</li>
        // </ul>
        
        // <p style="margin-bottom: 24px;">If you need any help, our team is here for you. Want a personalized walkthrough? Just reply to this email—we'll gladly schedule a time.</p>
        
        // <p style="margin-bottom: 24px;">Thanks again for choosing ProTeams.io. Let's build something great together.</p>
        // </div>
        // `,
        // });

        // const authHeaders = { Authorization: `Bearer ${getLoginToken()}` };
        // const res = await axiosInstance.post(
        //   `${BaseUrl}sendEmailData`,
        //   {
        //     email: emails,
        //     subject: subject,
        //     contenttxt: content,
        //   },
        //   {
        //     headers: {
        //       "Content-Type": "application/json",
        //       withCredentials: true,
        //       ...authHeaders,
        //     },
        //   }
        // );
      } else {
        if(newuser?.message === "Email is already registered"){
          setCurrentStep(1);
          showErrorMessage(newuser?.message);
        }
        showErrorMessage(newuser?.message);
        setCurrentStep(1);
      }
    }

    setState({ ...state, loading: false });
  };

  const { formState, loading, sRedirect } = state;
  const { classes } = props;

  return (
    <>
      {/* Progress indicator */}
      {/* <div className="space-y-2">
        <ProgressSteps currentStep={currentStep} totalSteps={2} />
      </div> */}
      {alreadyAcount ? (
        <div className="text-center mt-10 p-16">
          <p className="text-[16px] font-semibold text-red-500 mb-8">
            You already have an account with this email.
          </p>
          <p className="text-[15px] text-gray-700">
            Please{" "}
            <span
              className="text-[#2980ba] font-medium cursor-pointer underline"
              onClick={() => { navigate("/login"); setAlredyAccount(false); }}
            >
              log in
            </span>{" "}
            or use another email to create a new account.
          </p>
        </div>
      ) : (
        <>
          {currentStep === 1 ? (
            <RegisterStep1
              currentStep={currentStep}
              goToStep={goToStep}
              formState={formState}
              handleInputChange={handleInputChange}
              handleCancelAll={handleCancelAll}
              setErrorMessage={setErrorMessage}
              errorMessage={errorMessage}
              goNext={goNext}
              error={error}
              emailError={emailError}
              loading={loading}
            />
          ) : null}

          {currentStep === 2 ? (
            <RegisterStep2
              currentStep={currentStep}
              goToStep={goToStep}
              formState={formState}
              handleInputChange={handleInputChange}
              handleCancelAll={handleCancelAll}
              userRegister={userRegister}
              industry={industry}
              setErrorMessage={setErrorMessage}
              errorMessage={errorMessage}
              loading={loading}
              onChangeCheckbox={onChangeCheckbox}
              state={state}
              error={error}
              peoples={peoples}
            />
          ) : null}
        </>
      )}
      {/* <div className="loginbottom">
        <FormControlLabel
          control={
            <Checkbox
              value="yes"
              color="primary"
              checked={Boolean(state?.terms ? state?.terms : false)}
              onChange={onChangeCheckbox}
            />
          }
          label={
            <div className="text-center text-sm text-gray-500">
              I confirm that I have read and agree to the{" "}
              <Link
                to="#"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-600 hover:text-green-800 font-medium"
              >
                Terms and Conditions
              </Link>
              .
            </div>
          }
        />
      </div>
      {error !== "" && (<div className="small error color-danger">{error}</div>)} */}
    </>
  );
};

export default RegisterForm;
